export default __webpack_public_path__ + "static/media/avatar_51.59f0e577.png";